// extracted by mini-css-extract-plugin
export default {"root":"_20LtF","large":"_1TKG5","hoverable":"_2vf_z","medium":"_3z2k_","small":"_3KyHq"};